import React, { FC } from 'react';
import { connect } from 'react-redux';

import cn from 'classnames';
import { Button } from 'components/UtilElements';
import { AuthAction, AuthActions } from 'containers/AuthStateManager';
import { AuthScreens } from 'globals/constants';
import { RootState } from 'redux/reducers';

interface GetStartedProps {
  accessData: SessionData | null;
  setAuthState(action: AuthAction): void;
}

const GetStarted: FC<GetStartedProps> = ({ accessData, setAuthState }) => {
  if (!accessData) return null;

  return (
    <>
      <h2 className='auth__title'>Get started</h2>
      <div className='auth__panel'>
        <p className='auth__message'>
          <strong>{accessData.emailId}</strong> is not linked to an account on Acadly. Please create a new
          account to proceed.
        </p>
        <div className='auth__action-container'>
          <Button
            type='ghost'
            selector={cn('btn-primary', 'auth__action')}
            onRipple={() => {
              setAuthState({
                type: AuthActions.SET_SCREEN_WITH_CONTEXT,
                payload: { context: 'email', screen: AuthScreens.VERIFY_CODE },
              });
            }}
          >
            CREATE A NEW ACADLY ACCOUNT
          </Button>
          {/* <Button
            type='ghost'
            selector={cn('btn-primary', 'auth__action')}
            onRipple={() => {
              setAuthState({
                type: AuthActions.SET_SCREEN_WITH_CONTEXT,
                payload: { context: 'link', screen: AuthScreens.GET_EMAIL },
              });
            }}
          >
            LINK MY EXISTING ACADLY ACCOUNT
          </Button> */}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = ({ getAccess }: RootState) => {
  return { accessData: getAccess };
};

export default connect(mapStateToProps)(GetStarted);
